import React from 'react'
import Chip from '@mui/material/Chip'
import { Tooltip, Zoom } from '@mui/material'

// Marks applications rebuilt from their evaluations because the Acuant extract
// had no application record for them (see back-end-v2 AcuantCsvImporter).
export const KycArchivePartialRecordChip: React.FC = () => {
  return (
    <Tooltip title={'Application record missing from the Acuant extract - built from its evaluations'} TransitionComponent={Zoom} arrow placement='bottom'>
      <Chip label={'Partial record'} variant='outlined' color={'warning'} size={'small'} />
    </Tooltip>
  )
}
